import GSObject from "../../../Base/GSObject";

export default class Appearance extends GSObject {
    constructor(gsoParent) {
        super(gsoParent);

        this.state = gsoParent;
    }
}